import Model, { attr, belongsTo, hasMany } from "@ember-data/model";
import type BioExamReportTemplate from "parog-web/models/bio-exam-report-template";
import type HealthCentre from "parog-web/models/health-centre";

export default class PrescriptionConfiguration extends Model {
  @hasMany("bio-exam-report-template", {
    async: false,
    inverse: "prescriptionConfiguration"
  })
  declare bioExamReportTemplates: BioExamReportTemplate[];
  @attr("string") defaultBiologyPrescriptionAldComment?: string;
  @attr("string") defaultBiologyPrescriptionAldHeader?: string;
  @attr("string") defaultBiologyPrescriptionComment?: string;
  @belongsTo("health-centre", {
    async: false,
    inverse: "prescriptionConfigurations"
  })
  declare healthCentre: HealthCentre;
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module "ember-data/types/registries/model" {
  export default interface ModelRegistry {
    "prescription-configuration": PrescriptionConfiguration;
  }
}
